import React from "react";
import { BookOpenIcon, GiftIcon } from "lucide-react";
import { OfferBox } from "../OfferBox";
import { MOCKUP_IMAGE } from "../../data/content";
export function Hero() {
  return <header className="bg-navy-950 text-white" data-id="element-217" data-mp="cw4cbt4fqmtv">
      <div className="border-b border-white/10 bg-navy-900" data-id="element-218" data-mp="cu9syj8tb2rw">
        <p className="mx-auto max-w-6xl px-4 py-2.5 text-center text-[11px] font-semibold uppercase tracking-[0.18em] text-electric-light sm:text-xs" data-id="element-219" data-mp="hvh1ikis45zm">
          By Michael Carter · Aesthetic Laser Education
        </p>
      </div>

      <div className="mx-auto grid max-w-6xl gap-6 px-4 pt-8 sm:pt-12 lg:grid-cols-2 lg:gap-x-12 lg:pt-16" data-id="element-220" data-mp="qub1mkvbjehx">
        <div className="text-center lg:col-start-1 lg:row-start-1 lg:self-end lg:text-left" data-id="element-221" data-mp="vmvspemubdhr">
          <p className="font-display text-lg font-semibold uppercase leading-snug text-cta sm:text-xl" data-id="element-222" data-mp="10kxfa9jh5uxz">
            Master the fundamentals of aesthetic laser education with one organized 6-volume reference
            collection
          </p>
          <h1 className="mt-4 font-display text-[52px] font-extrabold uppercase leading-[0.92] sm:text-7xl lg:text-[80px]" data-id="element-223" data-mp="9nswfo0ko1cm">
            Aesthetic Laser <span className="block text-electric-light" data-id="element-224" data-mp="4ny8ntc3frvs">Clinical Blueprint™</span>
          </h1>
          <p className="mt-4 font-display text-lg font-semibold uppercase tracking-wide text-white/85 sm:text-xl" data-id="element-225" data-mp="3vw2f71fzd6tj">
            A structured educational reference system for aesthetic laser professionals
          </p>
        </div>

        <div className="-mx-2 sm:mx-0 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-226" data-mp="sgeri63nnnw5">
          <img src={MOCKUP_IMAGE} alt="Aesthetic Laser Clinical Blueprint collection: six volumes, worksheets and tablet resources" className="mx-auto w-full max-w-xl rounded-3xl bg-white" data-id="element-227" data-mp="nhajvjwdpy7x" />
        </div>

        <div className="text-center lg:col-start-1 lg:row-start-2 lg:self-start lg:text-left" data-id="element-228" data-mp="1b51umj29u373">
          <p className="text-base text-white/75 sm:text-lg" data-id="element-229" data-mp="16dtl7n0xyhtx">
            Bring laser technology fundamentals, skin assessment references, treatment-planning concepts,
            safety considerations, and clinical documentation resources together in one organized
            educational collection.
          </p>
          <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-230" data-mp="2qv2u3dd8vpey">
            <div className="flex items-center gap-3 rounded-2xl bg-white/5 p-3 text-left ring-1 ring-white/10 sm:p-4" data-id="element-231" data-mp="2vv78mxulea2j">
              <BookOpenIcon className="h-7 w-7 shrink-0 text-electric-light" aria-hidden="true" data-id="element-232" data-mp="2huwgzslgkrgb" />
              <p className="leading-tight" data-id="element-233" data-mp="2mv23kucvfnrj">
                <span className="block font-display text-3xl font-extrabold" data-id="element-234" data-mp="2mvtys42k3jha">6</span>
                <span className="text-xs font-semibold uppercase tracking-wide text-white/70 sm:text-sm" data-id="element-235" data-mp="27yjnovttsfm3">
                  Specialized volumes
                </span>
              </p>
            </div>
            <div className="flex items-center gap-3 rounded-2xl bg-white/5 p-3 text-left ring-1 ring-white/10 sm:p-4" data-id="element-236" data-mp="676jk8zombr3">
              <GiftIcon className="h-7 w-7 shrink-0 text-cta" aria-hidden="true" data-id="element-237" data-mp="b46qem4cvij9" />
              <p className="leading-tight" data-id="element-238" data-mp="1vnk02lj9h90c">
                <span className="block font-display text-3xl font-extrabold" data-id="element-239" data-mp="1qnxla7nsbkpf">5</span>
                <span className="text-xs font-semibold uppercase tracking-wide text-white/70 sm:text-sm" data-id="element-240" data-mp="1qm32ozzzk4oi">
                  Exclusive bonuses
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-4 pb-16 pt-10" data-id="element-241" data-mp="2ecqmojn6ekrf">
        <OfferBox dark ctaId="first-cta" heading="Your complete collection today" label="Get The Blueprint Now" data-id="element-242" data-mp="2efcvemlsz6b8" />
        <p className="mx-auto mt-5 max-w-xl text-center text-sm text-white/65" data-id="element-243" data-mp="2obfvlmx3guvj">
          A complete educational collection featuring six specialized volumes and five complementary
          professional resources.
        </p>
      </div>
    </header>;
}